<template>
  <v-tooltip top>
    <v-btn icon slot="activator" @click="del()">
      <v-icon color="pink">delete</v-icon>
    </v-btn>
    <span>Delete</span>
  </v-tooltip>
</template>

<script>
export default {
  methods: {
    del() {
      this.$emit("delete");
    }
  }
};
</script>

<style>
</style>
